<template>
  <div class="container" @click="$emit('togglePreview')">
    <img v-if="!isMS" class="preview" :src="src" alt="" />
    <div v-if="isMS" class="preview" :style="{ 'background-image': `url(${src})`}"></div>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import userAgent from '@/libs/user-agent'

export default {
  props: ['attachment'],
  computed: {
    src: function () {
      return imageProxy.proxy(this.attachment.url, {})
    },
    isMS: function () {
      return userAgent.isIE11() || userAgent.isEdge()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

$maxHeight: 500px;

.container {
  width: 100%;
  height: 100%;
  cursor: pointer;

  @include mobile {
    cursor: initial;
  }

  img.preview {
    max-height: $maxHeight;
    object-fit: contain;
    object-position: center center;
    height: 100%;
    width: 100%;
  }
  img {
    display: block;
  }

  div.preview {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 70vh;
    max-height: $maxHeight;
  }
}
</style>
